import React from "react";
import "./Fee.css"; // Custom CSS for the fee page
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGraduate,
  faChalkboardTeacher,
} from "@fortawesome/free-solid-svg-icons";

const Fee = () => {
  return (
    <section className="fee-container">
      <h1 className="fee-title">Our Coaching Fee</h1>
      <p className="fee-intro">
        Invest in your future with our high-quality coaching. Our fees are
        designed to provide exceptional value for both 11th and 12th grade
        students. Learn more about our fee structure below and take the first
        step towards academic excellence!
      </p>
      <div className="fee-details">
        <div className="fee-item">
          <FontAwesomeIcon icon={faUserGraduate} className="fee-icon" />
          <h2>11th Grade</h2>
          <p className="fee-amount">₹6000</p>
        </div>
        <div className="fee-item">
          <FontAwesomeIcon icon={faChalkboardTeacher} className="fee-icon" />
          <h2>12th Grade</h2>
          <p className="fee-amount">₹6000</p>
        </div>
      </div>
      <div className="fee-action">
        <p className="enroll-info">
          Interested in enrolling? Please
          <Link to="/contact" className="contact-link">
            {" "}
            Contact
          </Link>
          us for more details and to complete your enrollment.
        </p>
      </div>
    </section>
  );
};

export default Fee;
